import useDocumentTitle from "hooks/useDocumentTitle";
import { useUrlTab } from "hooks/useUrlTab";
import { TabPanel, TabView } from "primereact/tabview";
import { Navigate } from "react-router-dom";

import { HstImportsTab } from "./components/HstImportsTab/HstImportsTab";
import { HstPaymentSyncTab } from "./components/HstPaymentSyncTab/HstPaymentSyncTab";

// One entry per tab, in tab order. Each is addressable as `/integrations?tab=<key>`, and the
// panels are rendered from this list so a key can never point at the wrong panel.
// `/hst-sync`, the old standalone payment-sync page, redirects to `?tab=hst-sync` (CLE-2877).
export const INTEGRATION_TABS = [
  { key: "hst-imports", header: "HST Imports", Tab: HstImportsTab },
  { key: "hst-sync", header: "HST Payment Sync", Tab: HstPaymentSyncTab },
] as const;

const INTEGRATION_TAB_KEYS = INTEGRATION_TABS.map((tab) => tab.key);

// Mounted at `/hst-sync` so old bookmarks and Slack links open the payment-sync tab.
export function HstSyncRedirect() {
  return <Navigate to="/integrations?tab=hst-sync" replace />;
}

// SuperAdmin-only operations for hospital data integrations. One tab per integration;
// add new ones as further entries in INTEGRATION_TABS.
export function Integrations() {
  useDocumentTitle("Integrations");
  const { activeIndex, setActiveIndex } = useUrlTab(INTEGRATION_TAB_KEYS);

  return (
    <div className="p-4">
      <h1 className="mt-0 mb-3">Integrations</h1>
      {/*
        Both tabs stay mounted, so switching tabs keeps each one's filters, page and open
        dialogs, as the standalone pages did.
      */}
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        renderActiveOnly={false}
      >
        {INTEGRATION_TABS.map(({ key, header, Tab }) => (
          <TabPanel key={key} header={header}>
            <Tab />
          </TabPanel>
        ))}
      </TabView>
    </div>
  );
}
